// src/components/Breadcrumb.js
import { useLocation, Link } from 'react-router-dom';
import { getProcessedMenu } from '../utils/menu';

const findTrail = (items, pathname, trail = []) => {
    for (const item of items) {
        const currentTrail = [...trail, item];
        if (item.path === pathname) {
            return currentTrail;
        }
        if (item.children && item.children.length > 0) {
            const found = findTrail(item.children, pathname, currentTrail);
            if (found) return found;
        }
    }
    return null;
};

function Breadcrumb() {
    const location = useLocation();
    const menu = getProcessedMenu();
    const trail = findTrail(menu, location.pathname);

    if (!trail || trail.length === 0) return null;

    return (
        <div className="px-3 py-1 small border-bottom bg-white" style={{ fontSize: '0.8rem' }}>
            {trail.map((item, idx) => {
                const isLast = idx === trail.length - 1;
                const isLink = !isLast && item.path && (!item.children || item.children.length === 0);
                return (
                    <span key={item.id || item.path || item.name}>
                        {idx > 0 && <span className="mx-1 text-muted">/</span>}
                        {isLast ? (
                            <span className="fw-semibold text-dark">{item.name}</span>
                        ) : isLink ? (
                            <Link to={item.path} className="text-decoration-none text-muted">{item.name}</Link>
                        ) : (
                            <span className="text-muted">{item.name}</span>
                        )}
                    </span>
                );
            })}
        </div>
    );
}

export default Breadcrumb;
